import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs';
import { SchemaInformationModel } from '../../models/schema-information.model';

@Injectable()
export class SchemaInformationServices {

    constructor (private h: HttpClientService) { }

    /**
     * Get obsevable object of dto data
     *
     * @param {string} dto to connect
     * @returns {Observable<*>}
     */
    getSchema(schema: string, dto: string): Observable<SchemaInformationModel[]> {
        return this.h.get(schema + '/' + dto);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/entity/schema-information.services.ts